import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { ApprovalProvider } from '../partner/facilityInternalRequest/ContextAPI';
import Index from '../partner/facilityInternalRequest/Index';
import PermissionDenied from './PermissionDenied';

export default function FacilityInternalRequestPartner() {
    // Route Permission
    const { auth } = useAuth();
    const { route_permissions } = auth;
    if (!route_permissions['facility-internal-request-partner-init']) return <PermissionDenied />;

    return (
        <ApprovalProvider>
            <Index />
        </ApprovalProvider>
    );
}
